import React, { useState, useMemo } from 'react';
import { Box, HStack, Heading } from '@chakra-ui/react';
import useCollectionSearch from 'hooks/useCollectionSearch';
import AutoComplete from 'components/Segments/AutoComplete';
import { objectSort } from 'utils';

const CollectionSelector = props => {
  const {
    collection,
    isSearching,
    clearCollectionResults,
    searchCollection
  } = useCollectionSearch();
  // bubbles the selected user back up to the consumer / parent:
  const [name, setName] = useState('');
  const chooseUser = selectedItem => {
    let { item } = selectedItem;
    const pid = item.value;
    const profile = collection.find(one => one._id == pid || one.id == pid);
    if (profile) item = { ...item, ...profile };
    setName(item.label);
    props.onSelect(item);
  };

  const options = useMemo(() => {
    if (collection) {
      return collection
        .map(one => {
          return { value: one._id, label: one.fullname || one.label };
        })
        .sort(objectSort('label'));
    }
    return null;
  }, [collection]);

  return (
    <HStack className='input_box'>
      <Heading size={'sm'} color={props.disabled ? 'lightgray' : 'black'}>
        {props.label || 'Collection'}
      </Heading>
      <Box sx={{ border: props.disabled ? '1px solid lightgray' : '1px solid gray' }}>
        <AutoComplete
          isSearching={isSearching}
          options={options}
          onSelectOption={chooseUser}
          clearOptions={clearCollectionResults}
          searchOptions={searchCollection}
          searchParams={props.searchParams}
          defaultValue={name}
          // optional: can search on length of input, or space detection:
          searchOnSpace={false}
          searchOnLength={4}
          // these are defaults in the AC component, just doing show-n-tell here:
          // searchMsg='searching...'
          // typingMsg='keep typing...'
          inputPlaceholder={props.inputPlaceholder}
          disabled={props.disabled}
        />
      </Box>
    </HStack>
  );
};

export default CollectionSelector;
